import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'staffId'
})
export class StaffIdPipe implements PipeTransform {

  transform(value: string): any {
    return value.slice(0,8);
  }

}
